import React, { useEffect } from 'react'

import { Sidebar, Content } from './../Layout'
import { useLayout } from './../../context/Layout'

import ContainerCad from './ContainerCad'

export default function Container({ children, ...props }) {

    const { isScreenLogin } = useLayout()

    useEffect(() => {
        isScreenLogin(false)
    }, [])

    return (
        <>


            <div className="page-wrapper" style={{ marginLeft: 'var(--sidebar-width)', width: 'calc(100% - var(--sidebar-width))', minHeight: '100vh', transition: 'all 0.3s ease' }}>
                <Sidebar data={props.dataSidebar} markerSelecionado={props.markerSelecionado} />
                <Content {...props} >
                    {children}
                </Content>
            </div>
        </>
    )
}

export {
    ContainerCad
}